import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Clean%20minimal%20editorial%20flat%20lay%20photography%20of%20modern%20sneakers%20oversized%20hoodie%20caps%20and%20accessories%20arranged%20on%20light%20cream%20marble%20surface%20soft%20natural%20daylight%20casting%20gentle%20shadows%20fashion%20product%20catalog%20aesthetic%20warm%20beige%20and%20cream%20tones%20sophisticated%20ecommerce%20product%20display%20high%20end%20streetwear%20styling%20organized%20composition%20with%20negative%20space%20professional%20product%20photography&width=1920&height=1080&seq=hero-bg-superbuy-v2&orientation=landscape"
        alt="Superbuy Spreadsheet product research workspace"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="Superbuy Spreadsheet Research Workspace"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="inline-block text-xs md:text-sm font-medium text-background-50/90 bg-background-950/30 backdrop-blur-sm px-4 py-1.5 rounded-full mb-5 md:mb-6 whitespace-nowrap">
            Updated July 2026
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-4 md:mb-5">
            Superbuy Spreadsheet — Discover, Compare and Organize The Best Shopping Resources
          </h1>

          <p className="text-sm md:text-base text-background-200/90 max-w-xl mb-7 md:mb-8 leading-relaxed">
            The complete <strong>Superbuy Spreadsheet</strong> resource platform helping shoppers discover products, compare options, understand QC information, and make smarter purchasing decisions.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 px-6 py-3 rounded-md transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Superbuy Spreadsheet
              <i className="ri-arrow-right-line text-base"></i>
            </a>
            <Link
              to="/article/what-is-superbuy-spreadsheet"
              className="inline-flex items-center gap-2 text-sm font-medium text-background-50 border border-background-50/40 hover:bg-background-50/10 px-6 py-3 rounded-md transition-all whitespace-nowrap cursor-pointer"
            >
              View Complete Guide
              <i className="ri-book-open-line text-base"></i>
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-5 mt-7 md:mt-8">
            <span className="flex items-center gap-1.5 text-xs text-background-200/80 whitespace-nowrap">
              <i className="ri-checkbox-circle-line text-sm text-primary-300"></i>
              Updated Resources
            </span>
            <span className="flex items-center gap-1.5 text-xs text-background-200/80 whitespace-nowrap">
              <i className="ri-checkbox-circle-line text-sm text-primary-300"></i>
              Detailed Comparisons
            </span>
            <span className="flex items-center gap-1.5 text-xs text-background-200/80 whitespace-nowrap">
              <i className="ri-checkbox-circle-line text-sm text-primary-300"></i>
              Safety First Approach
            </span>
            <span className="flex items-center gap-1.5 text-xs text-background-200/80 whitespace-nowrap">
              <i className="ri-checkbox-circle-line text-sm text-primary-300"></i>
              Beginner Friendly
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}